import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Api } from 'app/core/api.service';

export interface Limits {
  dc: {
    pagesCount: number
  },
  ic: {
    pagesCount: number
  }
}

@Injectable()
export class LimitsService {

  constructor(private _api: Api) { }

  getLimit(): Observable<Limits> {
    return this._api
      .get('/v2/applications/limits')
      .pipe(
        map((response: Limits) => response)
      );
  }
}
